"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-5edf4f78"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "loading loading-2x"
};
const _hoisted_2 = { class: "settings-card-container" };
const _hoisted_3 = { class: "settings-title-wrapper" };
const _hoisted_4 = { class: "page-title-text" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { class: "settings-item" };
const _hoisted_7 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "シフト表", -1 /* HOISTED */));
const _hoisted_9 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフに「シフト管理」の閲覧権限を付与する。")
], -1 /* HOISTED */));
const _hoisted_11 = { class: "settings-input oplus-form-switch" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_13 = {
    key: 0,
    class: "settings-item"
};
const _hoisted_14 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "労務の閲覧・編集権限", -1 /* HOISTED */));
const _hoisted_16 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト編集者に交通費・労務費・人件費の閲覧権限、時給の編集権限を付与する")
], -1 /* HOISTED */));
const _hoisted_18 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_20 = {
    key: 1,
    class: "settings-item"
};
const _hoisted_21 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "確定", -1 /* HOISTED */));
const _hoisted_23 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "確定前のシフトに枠線を使用する")
], -1 /* HOISTED */));
const _hoisted_25 = { class: "settings-input oplus-form-switch" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_27 = { class: "settings-item" };
const _hoisted_28 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "日跨ぎ設定", -1 /* HOISTED */));
const _hoisted_30 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_31 = /*#__PURE__*/ (0, vue_2.createStaticVNode)("<div class=\"tooltip-wrapper\" data-v-5edf4f78><span class=\"tooltip-text\" data-v-5edf4f78>日を跨ぐシフトを2日に分ける。 <div class=\"split-slot-settings-sample\" data-v-5edf4f78><table class=\"split-table\" data-v-5edf4f78><thead data-v-5edf4f78><tr data-v-5edf4f78><th class=\"split-table-header\" data-v-5edf4f78>1月1日</th></tr></thead><tbody class=\"split-table-body\" data-v-5edf4f78><tr data-v-5edf4f78><td data-v-5edf4f78><div class=\"split-slot-chip\" data-v-5edf4f78><span data-v-5edf4f78>レジ</span><span data-v-5edf4f78>20:00 ~ 5:00</span></div></td></tr></tbody></table><!-- Arrow here --><i class=\"zmdi zmdi-arrow-right zmdi-hc-lg\" data-v-5edf4f78></i><table class=\"split-table\" data-v-5edf4f78><thead data-v-5edf4f78><tr data-v-5edf4f78><th class=\"split-table-header\" data-v-5edf4f78>1月1日</th><th class=\"split-table-header\" data-v-5edf4f78>1月2日</th></tr></thead><tbody class=\"split-table-body\" data-v-5edf4f78><tr data-v-5edf4f78><td data-v-5edf4f78><div class=\"split-slot-chip\" data-v-5edf4f78><span data-v-5edf4f78>レジ</span><span data-v-5edf4f78>20:00 ~ 23:59</span></div></td><td data-v-5edf4f78><div class=\"split-slot-chip\" data-v-5edf4f78><span data-v-5edf4f78>レジ</span><span data-v-5edf4f78>24:00 ~ 5:00</span></div></td></tr></tbody></table></div></span></div>", 1);
const _hoisted_32 = { class: "settings-input oplus-form-switch" };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_34 = { class: "settings-item" };
const _hoisted_35 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "希望シフト", -1 /* HOISTED */));
const _hoisted_37 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, [
        /*#__PURE__*/ (0, vue_2.createTextVNode)(" スタッフの希望と変更したシフトの両方を見れる機能。 "),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "本機能をONにすると:"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "-「戻す」ボタンが非表示となります。"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "- シフトをロックされている場合、スタッフはシフト提出ページで提出したシフトのみ閲覧できます。")
    ])
], -1 /* HOISTED */));
const _hoisted_39 = { class: "settings-input oplus-form-switch" };
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_41 = { class: "settings-item" };
const _hoisted_42 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "業務", -1 /* HOISTED */));
const _hoisted_44 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "業務一覧を表示する。")
], -1 /* HOISTED */));
const _hoisted_46 = { class: "settings-input oplus-form-switch" };
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_48 = { class: "settings-item" };
const _hoisted_49 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "デフォルト", -1 /* HOISTED */));
const _hoisted_51 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "デフォルトで表示される全体のシフト表")
], -1 /* HOISTED */));
const _hoisted_53 = { class: "d-flex flex-wrap settings-input" };
const _hoisted_54 = { class: "oplus-form-radio" };
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "週", -1 /* HOISTED */));
const _hoisted_57 = { class: "oplus-form-radio" };
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "月", -1 /* HOISTED */));
const _hoisted_60 = { class: "settings-item" };
const _hoisted_61 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "別々の費用", -1 /* HOISTED */));
const _hoisted_63 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト管理で交通費と労務費が別々に表示される。")
], -1 /* HOISTED */));
const _hoisted_65 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_67 = { class: "settings-item" };
const _hoisted_68 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "メモ", -1 /* HOISTED */));
const _hoisted_70 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト管理でメモが表示される。")
], -1 /* HOISTED */));
const _hoisted_72 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_74 = { class: "settings-item" };
const _hoisted_75 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "日表示", -1 /* HOISTED */));
const _hoisted_77 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "カレンダーを日表示にした際に、出勤時間が早い人順に並べられる")
], -1 /* HOISTED */));
const _hoisted_79 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_81 = { class: "settings-item" };
const _hoisted_82 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "業務時間", -1 /* HOISTED */));
const _hoisted_84 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "業務管理で作成した業務の時間表記設定")
], -1 /* HOISTED */));
const _hoisted_86 = { class: "d-flex flex-wrap settings-input justify-content-end flex-column" };
const _hoisted_87 = { class: "oplus-form-radio" };
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "表示しない", -1 /* HOISTED */));
const _hoisted_90 = { class: "oplus-form-radio" };
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "変更されたら表示", -1 /* HOISTED */));
const _hoisted_93 = { class: "oplus-form-radio" };
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "常に表示", -1 /* HOISTED */));
const _hoisted_96 = { class: "settings-item" };
const _hoisted_97 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "労務指標", -1 /* HOISTED */));
const _hoisted_99 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "労務の数値をシフト表に表示させる")
], -1 /* HOISTED */));
const _hoisted_101 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_102 = { class: "oplus-form-checkbox" };
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日数", -1 /* HOISTED */));
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_105 = { class: "oplus-form-checkbox" };
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "公休", -1 /* HOISTED */));
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_108 = { class: "oplus-form-checkbox" };
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "労働", -1 /* HOISTED */));
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_111 = { class: "oplus-form-checkbox" };
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "有休", -1 /* HOISTED */));
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_114 = { class: "settings-item" };
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "定休日")
], -1 /* HOISTED */));
const _hoisted_116 = { class: "d-flex flex-wrap justify-content-end settings-input" };
const _hoisted_117 = { class: "oplus-form-checkbox" };
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日", -1 /* HOISTED */));
const _hoisted_119 = ["checked"];
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_121 = { class: "oplus-form-checkbox" };
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "月", -1 /* HOISTED */));
const _hoisted_123 = ["checked"];
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_125 = { class: "oplus-form-checkbox" };
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "火", -1 /* HOISTED */));
const _hoisted_127 = ["checked"];
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_129 = { class: "oplus-form-checkbox" };
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "水", -1 /* HOISTED */));
const _hoisted_131 = ["checked"];
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_133 = { class: "oplus-form-checkbox" };
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "木", -1 /* HOISTED */));
const _hoisted_135 = ["checked"];
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_137 = { class: "oplus-form-checkbox" };
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "金", -1 /* HOISTED */));
const _hoisted_139 = ["checked"];
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_141 = { class: "oplus-form-checkbox" };
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "土", -1 /* HOISTED */));
const _hoisted_143 = ["checked"];
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_145 = { class: "settings-item" };
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name text-wrap" }, [
        /*#__PURE__*/ (0, vue_2.createTextVNode)("ボタン"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
        /*#__PURE__*/ (0, vue_2.createTextVNode)("のテキスト")
    ])
], -1 /* HOISTED */));
const _hoisted_147 = { class: "settings-multi-input settings-input w-40" };
const _hoisted_148 = { class: "settings-multi-item" };
const _hoisted_149 = { class: "oplus-form-checkbox" };
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-success" }, "○", -1 /* HOISTED */));
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_152 = { class: "settings-multi-item" };
const _hoisted_153 = { class: "oplus-form-checkbox" };
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-close zmdi-hc-lg text-error" })
], -1 /* HOISTED */));
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_156 = { class: "settings-multi-item" };
const _hoisted_157 = { class: "oplus-form-checkbox" };
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "有休", -1 /* HOISTED */));
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_160 = { class: "settings-multi-item" };
const _hoisted_161 = { class: "oplus-form-checkbox" };
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "半有休", -1 /* HOISTED */));
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_164 = { class: "settings-multi-item" };
const _hoisted_165 = { class: "oplus-form-checkbox" };
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "希望休", -1 /* HOISTED */));
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_168 = { class: "settings-item" };
const _hoisted_169 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name text-wrap" }, [
    /*#__PURE__*/ (0, vue_2.createTextVNode)("シフト提出"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)("のボタン")
], -1 /* HOISTED */));
const _hoisted_171 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト提出のボタンを非表示設定")
], -1 /* HOISTED */));
const _hoisted_173 = { class: "settings-multi-input settings-input" };
const _hoisted_174 = { class: "settings-multi-item" };
const _hoisted_175 = { class: "oplus-form-checkbox" };
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-success" }, "○", -1 /* HOISTED */));
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_178 = { class: "settings-multi-item" };
const _hoisted_179 = { class: "oplus-form-checkbox" };
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-close zmdi-hc-lg text-error" })
], -1 /* HOISTED */));
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_182 = { class: "settings-multi-item" };
const _hoisted_183 = { class: "oplus-form-checkbox" };
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "有休", -1 /* HOISTED */));
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_186 = { class: "settings-multi-item" };
const _hoisted_187 = { class: "oplus-form-checkbox" };
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "半有休", -1 /* HOISTED */));
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_190 = { class: "settings-multi-item" };
const _hoisted_191 = { class: "oplus-form-checkbox" };
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "法定休日", -1 /* HOISTED */));
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_194 = { class: "settings-multi-item" };
const _hoisted_195 = { class: "oplus-form-checkbox" };
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "text-error" }, "法定外休日", -1 /* HOISTED */));
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_198 = { class: "settings-item" };
const _hoisted_199 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name text-wrap" }, [
    /*#__PURE__*/ (0, vue_2.createTextVNode)("シフト提出"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)("の自由入力")
], -1 /* HOISTED */));
const _hoisted_201 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト提出の自由入力欄を非表示設定")
], -1 /* HOISTED */));
const _hoisted_203 = { class: "settings-multi-input settings-input" };
const _hoisted_204 = { class: "settings-multi-item" };
const _hoisted_205 = { class: "oplus-form-checkbox" };
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "ラベル", -1 /* HOISTED */));
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_208 = { class: "settings-multi-item" };
const _hoisted_209 = { class: "oplus-form-checkbox" };
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "から", -1 /* HOISTED */));
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_212 = { class: "settings-multi-item" };
const _hoisted_213 = { class: "oplus-form-checkbox" };
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "まで", -1 /* HOISTED */));
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_216 = { class: "settings-multi-item" };
const _hoisted_217 = { class: "oplus-form-checkbox" };
const _hoisted_218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "メモ", -1 /* HOISTED */));
const _hoisted_219 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_220 = { class: "settings-multi-item" };
const _hoisted_221 = { class: "oplus-form-checkbox" };
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "休憩時間", -1 /* HOISTED */));
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_224 = { class: "settings-multi-item" };
const _hoisted_225 = { class: "oplus-form-checkbox" };
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "コメント機能", -1 /* HOISTED */));
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_228 = { class: "settings-item" };
const _hoisted_229 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "業務を非表示", -1 /* HOISTED */));
const _hoisted_231 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト提出の業務を非表示")
], -1 /* HOISTED */));
const _hoisted_233 = { class: "settings-input oplus-form-switch" };
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_235 = { class: "settings-item" };
const _hoisted_236 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "前通知", -1 /* HOISTED */));
const _hoisted_238 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "出勤前の事前確認通知")
], -1 /* HOISTED */));
const _hoisted_240 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_241 = { class: "settings-item" };
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "週始め")
], -1 /* HOISTED */));
const _hoisted_243 = { class: "d-flex flex-wrap justify-content-end settings-input" };
const _hoisted_244 = { class: "oplus-form-radio" };
const _hoisted_245 = ["value"];
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_247 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日", -1 /* HOISTED */));
const _hoisted_248 = { class: "oplus-form-radio" };
const _hoisted_249 = ["value"];
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_251 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "月", -1 /* HOISTED */));
const _hoisted_252 = { class: "oplus-form-radio" };
const _hoisted_253 = ["value"];
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "火", -1 /* HOISTED */));
const _hoisted_256 = { class: "oplus-form-radio" };
const _hoisted_257 = ["value"];
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "水", -1 /* HOISTED */));
const _hoisted_260 = { class: "oplus-form-radio" };
const _hoisted_261 = ["value"];
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_263 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "木", -1 /* HOISTED */));
const _hoisted_264 = { class: "oplus-form-radio" };
const _hoisted_265 = ["value"];
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "金", -1 /* HOISTED */));
const _hoisted_268 = { class: "oplus-form-radio" };
const _hoisted_269 = ["value"];
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "土", -1 /* HOISTED */));
const _hoisted_272 = { class: "settings-item" };
const _hoisted_273 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "就業時間設定")
], -1 /* HOISTED */));
const _hoisted_274 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_275 = ["value"];
const _hoisted_276 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "時", -1 /* HOISTED */));
const _hoisted_277 = ["value"];
const _hoisted_278 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "時", -1 /* HOISTED */));
const _hoisted_279 = { class: "settings-item" };
const _hoisted_280 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "月始めの日")
], -1 /* HOISTED */));
const _hoisted_281 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_282 = ["value"];
const _hoisted_283 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日", -1 /* HOISTED */));
const _hoisted_284 = { class: "settings-item" };
const _hoisted_285 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-item-name-wrapper flex-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "年始めの月")
], -1 /* HOISTED */));
const _hoisted_286 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_287 = ["value"];
const _hoisted_288 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "月", -1 /* HOISTED */));
const _hoisted_289 = { class: "settings-item" };
const _hoisted_290 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_291 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "シフトの公休", -1 /* HOISTED */));
const _hoisted_292 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_293 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフが出した公休が「希望休」として表示される。")
], -1 /* HOISTED */));
const _hoisted_294 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_295 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_296 = { class: "settings-item" };
const _hoisted_297 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_298 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "業務の公休", -1 /* HOISTED */));
const _hoisted_299 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_300 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフが出した業務の公休が「希望休」として表示される。")
], -1 /* HOISTED */));
const _hoisted_301 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_302 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_303 = { class: "settings-item" };
const _hoisted_304 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_305 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "「○ x 有休」", -1 /* HOISTED */));
const _hoisted_306 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_307 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "「○」"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "「×」"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "「有休」"),
        /*#__PURE__*/ (0, vue_2.createTextVNode)("のボタンを非表示にする。 ")
    ])
], -1 /* HOISTED */));
const _hoisted_308 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_309 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_310 = { class: "settings-item" };
const _hoisted_311 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_312 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "スタッフロック", -1 /* HOISTED */));
const _hoisted_313 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_314 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "管理者が確定した日までのシフトは追加・編集が出来なくなる。")
], -1 /* HOISTED */));
const _hoisted_315 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_316 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_317 = { class: "settings-item" };
const _hoisted_318 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_319 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "確定されたシフト", -1 /* HOISTED */));
const _hoisted_320 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_321 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフが確定されたシフトしか見えない。シフト閲覧設定が必要。")
], -1 /* HOISTED */));
const _hoisted_322 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_323 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_324 = { class: "settings-item" };
const _hoisted_325 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_326 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "シフトをロック", -1 /* HOISTED */));
const _hoisted_327 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_328 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフのシフトをロック（以下の日にちからシフトを閲覧・提出出来なくする）")
], -1 /* HOISTED */));
const _hoisted_329 = { class: "d-flex flex-gap flex-wrap margin-left-auto" };
const _hoisted_330 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_331 = ["value"];
const _hoisted_332 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "年", -1 /* HOISTED */));
const _hoisted_333 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_334 = ["value"];
const _hoisted_335 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "月", -1 /* HOISTED */));
const _hoisted_336 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_337 = ["value"];
const _hoisted_338 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日", -1 /* HOISTED */));
const _hoisted_339 = { class: "settings-item" };
const _hoisted_340 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_341 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "連勤アラート", -1 /* HOISTED */));
const _hoisted_342 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_343 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "連勤より多い場合アラート")
], -1 /* HOISTED */));
const _hoisted_344 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_345 = ["value"];
const _hoisted_346 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日間", -1 /* HOISTED */));
const _hoisted_347 = { class: "settings-item" };
const _hoisted_348 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_349 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "連休アラート", -1 /* HOISTED */));
const _hoisted_350 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_351 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "連休より多い場合アラート")
], -1 /* HOISTED */));
const _hoisted_352 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_353 = ["value"];
const _hoisted_354 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "日間", -1 /* HOISTED */));
const _hoisted_355 = { class: "settings-item" };
const _hoisted_356 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_357 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "労務（週ごと）", -1 /* HOISTED */));
const _hoisted_358 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_359 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "週ごとの公休が最低日数に達していなければアラート ")
], -1 /* HOISTED */));
const _hoisted_360 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_361 = ["value"];
const _hoisted_362 = { class: "settings-item" };
const _hoisted_363 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_364 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "労務（月ごと）", -1 /* HOISTED */));
const _hoisted_365 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_366 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "月ごとの公休が最低日数に達していなければアラート ")
], -1 /* HOISTED */));
const _hoisted_367 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_368 = ["value"];
const _hoisted_369 = {
    key: 2,
    class: "settings-item"
};
const _hoisted_370 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_371 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "月最大出勤数", -1 /* HOISTED */));
const _hoisted_372 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_373 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフの月間出勤日数の上限を設定する（基準20日、最大26日）")
], -1 /* HOISTED */));
const _hoisted_374 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_375 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-max-label" }, "MAX", -1 /* HOISTED */));
const _hoisted_376 = { class: "labor-day-input-group" };
const _hoisted_377 = ["value"];
const _hoisted_378 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "labor-day-suffix" }, "日", -1 /* HOISTED */));
const _hoisted_379 = {
    key: 3,
    class: "settings-item"
};
const _hoisted_380 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_381 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "月最大休日数", -1 /* HOISTED */));
const _hoisted_382 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_383 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, " 全スタッフの月間休日数の上限を設定する")
], -1 /* HOISTED */));
const _hoisted_384 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_385 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-max-label" }, "MAX", -1 /* HOISTED */));
const _hoisted_386 = { class: "labor-day-input-group" };
const _hoisted_387 = ["value"];
const _hoisted_388 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "labor-day-suffix" }, "日", -1 /* HOISTED */));
const _hoisted_389 = {
    key: 4,
    class: "settings-item"
};
const _hoisted_390 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_391 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "週最大出勤数", -1 /* HOISTED */));
const _hoisted_392 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_393 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフの週間出勤日数の上限を設定する（基準5日、最大6日）")
], -1 /* HOISTED */));
const _hoisted_394 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_395 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-max-label" }, "MAX", -1 /* HOISTED */));
const _hoisted_396 = { class: "labor-day-input-group" };
const _hoisted_397 = ["value"];
const _hoisted_398 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "labor-day-suffix" }, "日", -1 /* HOISTED */));
const _hoisted_399 = {
    key: 5,
    class: "settings-item"
};
const _hoisted_400 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_401 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "週最大労務", -1 /* HOISTED */));
const _hoisted_402 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_403 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフの週労働時間の上限を設定する（基準40時間、最大51時間25分）")
], -1 /* HOISTED */));
const _hoisted_404 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_405 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-max-label" }, "MAX", -1 /* HOISTED */));
const _hoisted_406 = {
    key: 6,
    class: "settings-item"
};
const _hoisted_407 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_408 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "月最大労務", -1 /* HOISTED */));
const _hoisted_409 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_410 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "全スタッフの月間労働時間の上限を設定する（基準：160時間，最大：205時間） ")
], -1 /* HOISTED */));
const _hoisted_411 = { class: "form-label d-flex flex-center settings-input" };
const _hoisted_412 = {
    key: 7,
    class: "settings-item settings-item-wrap"
};
const _hoisted_413 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_414 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "残業起算時間", -1 /* HOISTED */));
const _hoisted_415 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_416 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "設定した時間を超える勤務に対し、時給の1.25倍の割増賃金を適用する（基準：8時間）")
], -1 /* HOISTED */));
const _hoisted_417 = { class: "settings-input oplus-form-switch" };
const _hoisted_418 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_419 = {
    key: 0,
    class: "overtime-start-time-sub d-flex flex-center"
};
const _hoisted_420 = { class: "oplus-form-checkbox show-overtime-start-time-checkbox" };
const _hoisted_421 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "シフト管理で残業が表示される。", -1 /* HOISTED */));
const _hoisted_422 = ["value"];
const _hoisted_423 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "時間", -1 /* HOISTED */));
const _hoisted_424 = {
    key: 0,
    class: "settings-card-container"
};
const _hoisted_425 = { class: "settings-title-wrapper" };
const _hoisted_426 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "計画管理", -1 /* HOISTED */));
const _hoisted_427 = { class: "settings-item" };
const _hoisted_428 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_429 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "メモ", -1 /* HOISTED */));
const _hoisted_430 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_431 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト表にメモを表示")
], -1 /* HOISTED */));
const _hoisted_432 = { class: "settings-input oplus-form-switch" };
const _hoisted_433 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_434 = { class: "settings-item" };
const _hoisted_435 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_436 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "売り上げ", -1 /* HOISTED */));
const _hoisted_437 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_438 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト表に売り上げを表示")
], -1 /* HOISTED */));
const _hoisted_439 = { class: "settings-input oplus-form-switch" };
const _hoisted_440 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_441 = { class: "settings-item" };
const _hoisted_442 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_443 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "利用人数", -1 /* HOISTED */));
const _hoisted_444 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_445 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト表に利用人数を表示")
], -1 /* HOISTED */));
const _hoisted_446 = { class: "settings-input oplus-form-switch" };
const _hoisted_447 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_448 = { class: "settings-item" };
const _hoisted_449 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_450 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "必要人数", -1 /* HOISTED */));
const _hoisted_451 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_452 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフト表に必要人数を表示")
], -1 /* HOISTED */));
const _hoisted_453 = { class: "settings-input oplus-form-switch" };
const _hoisted_454 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_455 = { class: "settings-card-container" };
const _hoisted_456 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-title-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "その他")
], -1 /* HOISTED */));
const _hoisted_457 = { class: "settings-item" };
const _hoisted_458 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_459 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "サポート", -1 /* HOISTED */));
const _hoisted_460 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_461 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "サポートチャットを消す。 (ページを更新する必要があります)")
], -1 /* HOISTED */));
const _hoisted_462 = { class: "settings-input oplus-form-switch" };
const _hoisted_463 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_464 = { class: "settings-item" };
const _hoisted_465 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_466 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "揭示板", -1 /* HOISTED */));
const _hoisted_467 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_468 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "スタッフが掲示板を作成・コメント出来なくする。（閲覧のみ）")
], -1 /* HOISTED */));
const _hoisted_469 = {
    key: 0,
    class: "pro-label ml-2"
};
const _hoisted_470 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_471 = { class: "settings-item" };
const _hoisted_472 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_473 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "自動作成最大連勤", -1 /* HOISTED */));
const _hoisted_474 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_475 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "自動シフト作成の際最大連勤を使う。")
], -1 /* HOISTED */));
const _hoisted_476 = {
    key: 0,
    class: "pro-label auto-label ml-2"
};
const _hoisted_477 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_478 = { class: "settings-item" };
const _hoisted_479 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_480 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "自動作成最大連休", -1 /* HOISTED */));
const _hoisted_481 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_482 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "自動シフト作成の際最大連休を使う。")
], -1 /* HOISTED */));
const _hoisted_483 = {
    key: 0,
    class: "pro-label auto-label ml-2"
};
const _hoisted_484 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "oplus-form-icon" }, null, -1 /* HOISTED */));
const _hoisted_485 = { class: "settings-item" };
const _hoisted_486 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_487 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "インターバル", -1 /* HOISTED */));
const _hoisted_488 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_489 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "自動作成時に勤務間インターバルを考慮したシフトを組むことができる")
], -1 /* HOISTED */));
const _hoisted_490 = {
    key: 0,
    class: "pro-label auto-label ml-2"
};
const _hoisted_491 = { class: "settings-submit-button-wrapper" };
const vue_3 = require("vue");
const ShiftManagementIcon_vue_1 = __importDefault(require("../icons/ShiftManagementIcon.vue"));
const PlanManagementIcon_vue_1 = __importDefault(require("../icons/PlanManagementIcon.vue"));
const InfoIcon_vue_1 = __importDefault(require("../icons/InfoIcon.vue"));
const common_1 = require("../../common/common");
const dateInt_1 = __importDefault(require("../../common/dateInt"));
const settings_1 = require("../../js/settings");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SettingsShiftContent',
    props: {
        shiftSettings: {
            type: Object,
            required: true,
        },
        permissions: {
            type: Object,
            required: true,
        },
        branchCanEditSettings: {
            type: Boolean,
            default: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isUpdating: {
            type: Boolean,
            default: false,
        },
        isDefaultSettingsPage: {
            type: Boolean,
            default: false,
        },
        selectedOem: {
            type: Number,
            required: true,
        }
    },
    emits: ["emit-shift-settings", "emit-open-branch-max-labor-modal"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const { hasProPerm, hasAutoPerm, hasTrialPerm } = props.permissions;
        const disabledBtn = (0, vue_3.computed)(() => {
            return !hasTrialPerm && !hasProPerm ? 'disabled-btn' : '';
        });
        const disabledAuto = (0, vue_3.computed)(() => {
            return !hasAutoPerm ? 'disabled-btn' : '';
        });
        const localSettingShiftLockDate = (0, vue_3.ref)({
            shiftLockYear: 0,
            shiftLockMonth: 0,
            shiftLockDay: 0,
        });
        const localSettingsData = (0, vue_3.ref)({ ...props.shiftSettings });
        const shiftNotification = (0, vue_3.computed)({
            get: () => {
                return (0, common_1.durationToKitchenTime)(localSettingsData.value.shiftNotification, "minutes");
            },
            set: (value) => {
                localSettingsData.value.shiftNotification = (0, common_1.kitchenTimeToDuration)(value, "minutes");
            }
        });
        const shiftInterval = (0, vue_3.computed)({
            get: () => {
                return (0, common_1.durationToKitchenTime)(localSettingsData.value.shiftInterval, "minutes");
            },
            set: (value) => {
                localSettingsData.value.shiftInterval = (0, common_1.kitchenTimeToDuration)(value, "minutes");
            }
        });
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": props.isUpdating,
            };
        });
        const disabledPage = (0, vue_3.computed)(() => {
            return {
                'disabled-page': !props.branchCanEditSettings,
            };
        });
        function handleMaxConsecutiveWorkdays(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.maxConsecutiveWorkdays = newVal;
        }
        function handleMaxConsecutiveDaysOff(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.maxConsecutiveDaysOff = newVal;
        }
        function handleStartOfMonthChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.monthStart = newVal;
        }
        function handleStartOfYearChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.yearStart = newVal;
        }
        function handleSummaryDayStartChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.summaryDayStart = newVal;
        }
        function handleSummaryDayEndChange(e) {
            let newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingsData.value.summaryDayEnd = newVal;
        }
        function handleShiftLockYearChange(e) {
            let newVal = (0, settings_1.convertInputValToInt)(e);
            if (!newVal) {
                newVal = localSettingShiftLockDate.value.shiftLockYear;
            }
            localSettingShiftLockDate.value.shiftLockYear = newVal;
        }
        function handleShiftLockMonthChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingShiftLockDate.value.shiftLockMonth = newVal;
        }
        function handleShiftLockDayChange(e) {
            const newVal = (0, settings_1.convertInputValToInt)(e);
            localSettingShiftLockDate.value.shiftLockDay = newVal;
        }
        function splitShiftLockDate() {
            const shiftLockDate = localSettingsData.value.shiftLockDate;
            if (shiftLockDate) {
                localSettingShiftLockDate.value.shiftLockYear = shiftLockDate.getFullYear();
                localSettingShiftLockDate.value.shiftLockMonth = shiftLockDate.getMonth() + 1;
                localSettingShiftLockDate.value.shiftLockDay = shiftLockDate.getDate();
            }
            else {
                localSettingShiftLockDate.value.shiftLockYear = new Date().getFullYear();
                localSettingShiftLockDate.value.shiftLockMonth = null;
                localSettingShiftLockDate.value.shiftLockDay = null;
            }
        }
        function makeShiftLockDate() {
            const lockYear = localSettingShiftLockDate.value.shiftLockYear;
            const lockMonth = localSettingShiftLockDate.value.shiftLockMonth;
            const lockDay = localSettingShiftLockDate.value.shiftLockDay;
            if (lockYear && lockMonth && lockDay) {
                localSettingsData.value.shiftLockDate = new Date(lockYear, lockMonth - 1, lockDay);
            }
            else {
                localSettingsData.value.shiftLockDate = undefined;
            }
        }
        function handleOvertimeHoursInput(e) {
            localSettingsData.value.overtimeStartTimeHours = Number(e.target.value);
        }
        function handleCloseDaysChange(e, index) {
            const target = e.target;
            if (target && 'checked' in target) {
                localSettingsData.value.closedWeekdays[index] = target.checked;
                return;
            }
            return localSettingsData.value.closedWeekdays[index] = false;
        }
        const emit = __emit;
        function handleCalendarClick() {
            emit("emit-open-branch-max-labor-modal");
        }
        function handleShiftSubmit() {
            if (!props.branchCanEditSettings) {
                return;
            }
            makeShiftLockDate();
            if (localSettingsData.value.summaryDayStart >= localSettingsData.value.summaryDayEnd) {
                return (0, settings_1.importAlertModal)().alert("invalid time on 就業時間設定, start time should be less than the end time");
            }
            emit("emit-shift-settings", localSettingsData);
        }
        (0, vue_3.watch)(() => props.shiftSettings, (newSettings) => {
            localSettingsData.value = newSettings;
            splitShiftLockDate();
        }, { immediate: true }); // we want to fetch the initial data, and then re-fetch the data whenever relevant state changes.
        return (_ctx, _cache) => {
            return (__props.isLoading)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1))
                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: 1,
                    ref: "settingsContainer",
                    class: (0, vue_2.normalizeClass)(["main-settings-container", disabledPage.value])
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createCommentVNode)(" Summary page settings "),
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (0, vue_2.createVNode)(ShiftManagementIcon_vue_1.default, { class: "page-title-text" }),
                            (0, vue_2.createElementVNode)("span", _hoisted_4, [
                                (0, vue_2.createTextVNode)(" シフト管理 "),
                                (__props.isDefaultSettingsPage)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_5, "（デフォルト設定）"))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" canView "),
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                _hoisted_8,
                                (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_10
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_11, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((localSettingsData.value.staffCanViewSummary) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.staffCanViewSummary]
                                ]),
                                _hoisted_12
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" ShowWageRelatedForNonOwners "),
                        (__props.isDefaultSettingsPage)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, [
                                (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                    _hoisted_15,
                                    (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_17
                                    ])
                                ]),
                                (!(0, vue_2.unref)(hasProPerm))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_18))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("label", {
                                    class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                                }, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((localSettingsData.value.showWageRelatedForNonOwners) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.showWageRelatedForNonOwners]
                                    ]),
                                    _hoisted_19
                                ], 2 /* CLASS */)
                            ]))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createCommentVNode)(" Confirm Shift Borders "),
                        (__props.isDefaultSettingsPage)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_20, [
                                (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                    _hoisted_22,
                                    (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_24
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_25, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((localSettingsData.value.confirmShiftBorder) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.confirmShiftBorder]
                                    ]),
                                    _hoisted_26
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createCommentVNode)(" splitNightShift "),
                        (0, vue_2.createElementVNode)("div", _hoisted_27, [
                            (0, vue_2.createElementVNode)("div", _hoisted_28, [
                                _hoisted_29,
                                (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_31
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_32, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((localSettingsData.value.splitNightShift) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.splitNightShift]
                                ]),
                                _hoisted_33
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" stackedRequest "),
                        (0, vue_2.createElementVNode)("div", _hoisted_34, [
                            (0, vue_2.createElementVNode)("div", _hoisted_35, [
                                _hoisted_36,
                                (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_38
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_39, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((localSettingsData.value.stackedRequest) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.stackedRequest]
                                ]),
                                _hoisted_40
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" showRoles "),
                        (0, vue_2.createElementVNode)("div", _hoisted_41, [
                            (0, vue_2.createElementVNode)("div", _hoisted_42, [
                                _hoisted_43,
                                (0, vue_2.createElementVNode)("div", _hoisted_44, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_45
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_46, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((localSettingsData.value.showRoles) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.showRoles]
                                ]),
                                _hoisted_47
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" defaultView "),
                        (0, vue_2.createElementVNode)("div", _hoisted_48, [
                            (0, vue_2.createElementVNode)("div", _hoisted_49, [
                                _hoisted_50,
                                (0, vue_2.createElementVNode)("div", _hoisted_51, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_52
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_53, [
                                (0, vue_2.createElementVNode)("label", _hoisted_54, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((localSettingsData.value.defaultView) = $event)),
                                        value: 0,
                                        type: "radio",
                                        name: "default-summary-view"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelRadio, localSettingsData.value.defaultView]
                                    ]),
                                    _hoisted_55,
                                    _hoisted_56
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_57, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((localSettingsData.value.defaultView) = $event)),
                                        value: 1,
                                        type: "radio",
                                        name: "default-summary-view"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelRadio, localSettingsData.value.defaultView]
                                    ]),
                                    _hoisted_58,
                                    _hoisted_59
                                ])
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" transportSummary "),
                        (0, vue_2.createElementVNode)("div", _hoisted_60, [
                            (0, vue_2.createElementVNode)("div", _hoisted_61, [
                                _hoisted_62,
                                (0, vue_2.createElementVNode)("div", _hoisted_63, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_64
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasProPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_65))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((localSettingsData.value.transportSummary) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.transportSummary]
                                ]),
                                _hoisted_66
                            ], 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" memoSummary "),
                        (0, vue_2.createElementVNode)("div", _hoisted_67, [
                            (0, vue_2.createElementVNode)("div", _hoisted_68, [
                                _hoisted_69,
                                (0, vue_2.createElementVNode)("div", _hoisted_70, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_71
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasProPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_72))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((localSettingsData.value.memoSummary) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.memoSummary]
                                ]),
                                _hoisted_73
                            ], 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" dwsSort "),
                        (0, vue_2.createElementVNode)("div", _hoisted_74, [
                            (0, vue_2.createElementVNode)("div", _hoisted_75, [
                                _hoisted_76,
                                (0, vue_2.createElementVNode)("div", _hoisted_77, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_78
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasProPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_79))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((localSettingsData.value.dwsSort) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.dwsSort]
                                ]),
                                _hoisted_80
                            ], 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" showRoleTimes "),
                        (0, vue_2.createElementVNode)("div", _hoisted_81, [
                            (0, vue_2.createElementVNode)("div", _hoisted_82, [
                                _hoisted_83,
                                (0, vue_2.createElementVNode)("div", _hoisted_84, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_85
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_86, [
                                (0, vue_2.createElementVNode)("label", _hoisted_87, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((localSettingsData.value.showRoleTimes) = $event)),
                                        value: 0,
                                        type: "radio",
                                        name: "show-role-times"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelRadio, localSettingsData.value.showRoleTimes]
                                    ]),
                                    _hoisted_88,
                                    _hoisted_89
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_90, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((localSettingsData.value.showRoleTimes) = $event)),
                                        value: 1,
                                        type: "radio",
                                        name: "show-role-times"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelRadio, localSettingsData.value.showRoleTimes]
                                    ]),
                                    _hoisted_91,
                                    _hoisted_92
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_93, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((localSettingsData.value.showRoleTimes) = $event)),
                                        value: 2,
                                        type: "radio",
                                        name: "show-role-times"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelRadio, localSettingsData.value.showRoleTimes]
                                    ]),
                                    _hoisted_94,
                                    _hoisted_95
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_96, [
                            (0, vue_2.createElementVNode)("div", _hoisted_97, [
                                _hoisted_98,
                                (0, vue_2.createElementVNode)("div", _hoisted_99, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_100
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasProPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_101))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("div", {
                                class: (0, vue_2.normalizeClass)(["d-flex flex-wrap justify-content-end settings-input", disabledBtn.value])
                            }, [
                                (0, vue_2.createElementVNode)("label", _hoisted_102, [
                                    (0, vue_2.createCommentVNode)(" isWorkCountInSummaryPage "),
                                    _hoisted_103,
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((localSettingsData.value.isWorkCountInSummaryPage) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.isWorkCountInSummaryPage]
                                    ]),
                                    _hoisted_104
                                ]),
                                (0, vue_2.createCommentVNode)(" isVacationCountInSummaryPage "),
                                (0, vue_2.createElementVNode)("label", _hoisted_105, [
                                    _hoisted_106,
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((localSettingsData.value.isVacationCountInSummaryPage) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.isVacationCountInSummaryPage]
                                    ]),
                                    _hoisted_107
                                ]),
                                (0, vue_2.createCommentVNode)(" isLaborInSummaryPage "),
                                (0, vue_2.createElementVNode)("label", _hoisted_108, [
                                    _hoisted_109,
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((localSettingsData.value.isLaborInSummaryPage) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.isLaborInSummaryPage]
                                    ]),
                                    _hoisted_110
                                ]),
                                (0, vue_2.createCommentVNode)(" isPTOCountInSummaryPage "),
                                (0, vue_2.createElementVNode)("label", _hoisted_111, [
                                    _hoisted_112,
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((localSettingsData.value.isPTOCountInSummaryPage) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.isPTOCountInSummaryPage]
                                    ]),
                                    _hoisted_113
                                ])
                            ], 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" closedWeekdays "),
                        (0, vue_2.createElementVNode)("div", _hoisted_114, [
                            _hoisted_115,
                            (0, vue_2.createElementVNode)("div", _hoisted_116, [
                                (0, vue_2.createElementVNode)("label", _hoisted_117, [
                                    _hoisted_118,
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: _cache[18] || (_cache[18] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).SUN))),
                                        checked: localSettingsData.value.closedWeekdays[0],
                                        name: "weekday-start",
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_119),
                                    _hoisted_120
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_121, [
                                    _hoisted_122,
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: _cache[19] || (_cache[19] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).MON))),
                                        checked: localSettingsData.value.closedWeekdays[1],
                                        name: "weekday-start",
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_123),
                                    _hoisted_124
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_125, [
                                    _hoisted_126,
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: _cache[20] || (_cache[20] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).TUE))),
                                        checked: localSettingsData.value.closedWeekdays[2],
                                        name: "weekday-start",
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_127),
                                    _hoisted_128
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_129, [
                                    _hoisted_130,
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: _cache[21] || (_cache[21] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).WED))),
                                        checked: localSettingsData.value.closedWeekdays[3],
                                        name: "weekday-start",
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_131),
                                    _hoisted_132
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_133, [
                                    _hoisted_134,
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: _cache[22] || (_cache[22] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).THUR))),
                                        checked: localSettingsData.value.closedWeekdays[4],
                                        name: "weekday-start",
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_135),
                                    _hoisted_136
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_137, [
                                    _hoisted_138,
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: _cache[23] || (_cache[23] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).FRI))),
                                        checked: localSettingsData.value.closedWeekdays[5],
                                        name: "weekday-start",
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_139),
                                    _hoisted_140
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_141, [
                                    _hoisted_142,
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: _cache[24] || (_cache[24] = ($event) => (handleCloseDaysChange($event, (0, vue_2.unref)(dateInt_1.default).SAT))),
                                        checked: localSettingsData.value.closedWeekdays[6],
                                        name: "weekday-start",
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_143),
                                    _hoisted_144
                                ])
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" Change Shift button in Modal "),
                        (0, vue_2.createElementVNode)("div", _hoisted_145, [
                            _hoisted_146,
                            (0, vue_2.createElementVNode)("div", _hoisted_147, [
                                (0, vue_2.createElementVNode)("div", _hoisted_148, [
                                    (0, vue_2.createCommentVNode)(" shiftWorkText "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_149, [
                                        _hoisted_150,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((localSettingsData.value.shiftWorkText) = $event)),
                                            class: "form-input form-small",
                                            type: "text"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelText, localSettingsData.value.shiftWorkText]
                                        ]),
                                        _hoisted_151
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_152, [
                                    (0, vue_2.createCommentVNode)(" shiftOffText "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_153, [
                                        _hoisted_154,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((localSettingsData.value.shiftOffText) = $event)),
                                            class: "form-input form-small",
                                            type: "text"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelText, localSettingsData.value.shiftOffText]
                                        ]),
                                        _hoisted_155
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_156, [
                                    (0, vue_2.createCommentVNode)(" shiftPTOText "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_157, [
                                        _hoisted_158,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((localSettingsData.value.shiftPTOText) = $event)),
                                            class: "form-input form-small",
                                            type: "text"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelText, localSettingsData.value.shiftPTOText]
                                        ]),
                                        _hoisted_159
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_160, [
                                    (0, vue_2.createCommentVNode)(" shiftHalfPTOText "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_161, [
                                        _hoisted_162,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((localSettingsData.value.shiftHalfPTOText) = $event)),
                                            class: "form-input form-small",
                                            type: "text"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelText, localSettingsData.value.shiftHalfPTOText]
                                        ]),
                                        _hoisted_163
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_164, [
                                    (0, vue_2.createCommentVNode)(" shiftStaffOffText "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_165, [
                                        _hoisted_166,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((localSettingsData.value.shiftStaffOffText) = $event)),
                                            class: "form-input form-small",
                                            type: "text"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelText, localSettingsData.value.shiftStaffOffText]
                                        ]),
                                        _hoisted_167
                                    ])
                                ])
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" Hide Shift button in Modal "),
                        (0, vue_2.createElementVNode)("div", _hoisted_168, [
                            (0, vue_2.createElementVNode)("div", _hoisted_169, [
                                _hoisted_170,
                                (0, vue_2.createElementVNode)("div", _hoisted_171, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_172
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_173, [
                                (0, vue_2.createElementVNode)("div", _hoisted_174, [
                                    (0, vue_2.createCommentVNode)(" IsHidingTypeOInShiftModal "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_175, [
                                        _hoisted_176,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((localSettingsData.value.isHidingTypeOInShiftModal) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypeOInShiftModal]
                                        ]),
                                        _hoisted_177
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_178, [
                                    (0, vue_2.createCommentVNode)(" IsHidingTypeXInShiftModal "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_179, [
                                        _hoisted_180,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => ((localSettingsData.value.isHidingTypeXInShiftModal) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypeXInShiftModal]
                                        ]),
                                        _hoisted_181
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_182, [
                                    (0, vue_2.createCommentVNode)(" IsHidingTypePTOInShiftModal "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_183, [
                                        _hoisted_184,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => ((localSettingsData.value.isHidingTypePTOInShiftModal) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypePTOInShiftModal]
                                        ]),
                                        _hoisted_185
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_186, [
                                    (0, vue_2.createCommentVNode)(" IsHidingTypeHalfPTOInShiftModal "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_187, [
                                        _hoisted_188,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((localSettingsData.value.isHidingTypeHalfPTOInShiftModal) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypeHalfPTOInShiftModal]
                                        ]),
                                        _hoisted_189
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_190, [
                                    (0, vue_2.createCommentVNode)(" IsHidingTypePublicHolidayInShiftModal "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_191, [
                                        _hoisted_192,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => ((localSettingsData.value.isHidingTypePublicHolidayInShiftModal) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypePublicHolidayInShiftModal]
                                        ]),
                                        _hoisted_193
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_194, [
                                    (0, vue_2.createCommentVNode)(" IsHidingTypeOtherHolidayInShiftModal "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_195, [
                                        _hoisted_196,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => ((localSettingsData.value.isHidingTypeOtherHolidayInShiftModal) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isHidingTypeOtherHolidayInShiftModal]
                                        ]),
                                        _hoisted_197
                                    ])
                                ])
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" Hide Form Fields in Modal "),
                        (0, vue_2.createElementVNode)("div", _hoisted_198, [
                            (0, vue_2.createElementVNode)("div", _hoisted_199, [
                                _hoisted_200,
                                (0, vue_2.createElementVNode)("div", _hoisted_201, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_202
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_203, [
                                (0, vue_2.createElementVNode)("div", _hoisted_204, [
                                    (0, vue_2.createCommentVNode)(" isHidingPurposeInShiftModal "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_205, [
                                        _hoisted_206,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((localSettingsData.value.isHidingPurposeInShiftModal) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isHidingPurposeInShiftModal]
                                        ]),
                                        _hoisted_207
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_208, [
                                    (0, vue_2.createCommentVNode)(" isHidingFromInShiftModal "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_209, [
                                        _hoisted_210,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event) => ((localSettingsData.value.isHidingFromInShiftModal) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isHidingFromInShiftModal]
                                        ]),
                                        _hoisted_211
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_212, [
                                    (0, vue_2.createCommentVNode)(" isHidingToInShiftModal "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_213, [
                                        _hoisted_214,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event) => ((localSettingsData.value.isHidingToInShiftModal) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isHidingToInShiftModal]
                                        ]),
                                        _hoisted_215
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_216, [
                                    (0, vue_2.createCommentVNode)(" isHidingMemoInShiftModal "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_217, [
                                        _hoisted_218,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event) => ((localSettingsData.value.isHidingMemoInShiftModal) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isHidingMemoInShiftModal]
                                        ]),
                                        _hoisted_219
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_220, [
                                    (0, vue_2.createCommentVNode)(" isHidingRestInShiftModal "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_221, [
                                        _hoisted_222,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => ((localSettingsData.value.isHidingRestInShiftModal) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isHidingRestInShiftModal]
                                        ]),
                                        _hoisted_223
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_224, [
                                    (0, vue_2.createCommentVNode)(" isHidingCommentInputInShiftModal "),
                                    (0, vue_2.createElementVNode)("label", _hoisted_225, [
                                        _hoisted_226,
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => ((localSettingsData.value.isHidingCommentInputInShiftModal) = $event)),
                                            type: "checkbox"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelCheckbox, localSettingsData.value.isHidingCommentInputInShiftModal]
                                        ]),
                                        _hoisted_227
                                    ])
                                ])
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" IsHidingRoleInStaffModal "),
                        (0, vue_2.createElementVNode)("div", _hoisted_228, [
                            (0, vue_2.createElementVNode)("div", _hoisted_229, [
                                _hoisted_230,
                                (0, vue_2.createElementVNode)("div", _hoisted_231, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_232
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_233, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event) => ((localSettingsData.value.isHidingRoleInStaffModal) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.isHidingRoleInStaffModal]
                                ]),
                                _hoisted_234
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" shiftNotification "),
                        (0, vue_2.createElementVNode)("div", _hoisted_235, [
                            (0, vue_2.createElementVNode)("div", _hoisted_236, [
                                _hoisted_237,
                                (0, vue_2.createElementVNode)("div", _hoisted_238, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_239
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasProPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_240))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["form-label settings-input", disabledBtn.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event) => ((shiftNotification).value = $event)),
                                    class: "form-input oplus-input-time",
                                    type: "time"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelText, shiftNotification.value]
                                ])
                            ], 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" startOfWeek "),
                        (0, vue_2.createElementVNode)("div", _hoisted_241, [
                            _hoisted_242,
                            (0, vue_2.createElementVNode)("div", _hoisted_243, [
                                (0, vue_2.createElementVNode)("label", _hoisted_244, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                        value: (0, vue_2.unref)(dateInt_1.default).SUN,
                                        type: "radio",
                                        name: "default-start-weekday"
                                    }, null, 8 /* PROPS */, _hoisted_245), [
                                        [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                    ]),
                                    _hoisted_246,
                                    _hoisted_247
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_248, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                        value: (0, vue_2.unref)(dateInt_1.default).MON,
                                        type: "radio",
                                        name: "default-start-weekday"
                                    }, null, 8 /* PROPS */, _hoisted_249), [
                                        [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                    ]),
                                    _hoisted_250,
                                    _hoisted_251
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_252, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                        value: (0, vue_2.unref)(dateInt_1.default).TUE,
                                        type: "radio",
                                        name: "default-start-weekday"
                                    }, null, 8 /* PROPS */, _hoisted_253), [
                                        [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                    ]),
                                    _hoisted_254,
                                    _hoisted_255
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_256, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                        value: (0, vue_2.unref)(dateInt_1.default).WED,
                                        type: "radio",
                                        name: "default-start-weekday"
                                    }, null, 8 /* PROPS */, _hoisted_257), [
                                        [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                    ]),
                                    _hoisted_258,
                                    _hoisted_259
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_260, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                        value: (0, vue_2.unref)(dateInt_1.default).THUR,
                                        type: "radio",
                                        name: "default-start-weekday"
                                    }, null, 8 /* PROPS */, _hoisted_261), [
                                        [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                    ]),
                                    _hoisted_262,
                                    _hoisted_263
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_264, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                        value: (0, vue_2.unref)(dateInt_1.default).FRI,
                                        type: "radio",
                                        name: "default-start-weekday"
                                    }, null, 8 /* PROPS */, _hoisted_265), [
                                        [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                    ]),
                                    _hoisted_266,
                                    _hoisted_267
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_268, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event) => ((localSettingsData.value.weekStart) = $event)),
                                        value: (0, vue_2.unref)(dateInt_1.default).SAT,
                                        type: "radio",
                                        name: "default-start-weekday"
                                    }, null, 8 /* PROPS */, _hoisted_269), [
                                        [vue_2.vModelRadio, localSettingsData.value.weekStart]
                                    ]),
                                    _hoisted_270,
                                    _hoisted_271
                                ])
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" Summary Day Start * End "),
                        (0, vue_2.createElementVNode)("div", _hoisted_272, [
                            _hoisted_273,
                            (0, vue_2.createElementVNode)("label", _hoisted_274, [
                                (0, vue_2.createElementVNode)("input", {
                                    onChange: handleSummaryDayStartChange,
                                    value: localSettingsData.value.summaryDayStart,
                                    class: "form-input form-extra-small",
                                    type: "text",
                                    placeholder: "1"
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_275),
                                _hoisted_276,
                                (0, vue_2.createTextVNode)(" 〜 "),
                                (0, vue_2.createElementVNode)("input", {
                                    onChange: handleSummaryDayEndChange,
                                    value: localSettingsData.value.summaryDayEnd,
                                    class: "form-input form-extra-small",
                                    type: "text",
                                    placeholder: "24"
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_277),
                                _hoisted_278
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" startOfMonth "),
                        (0, vue_2.createElementVNode)("div", _hoisted_279, [
                            _hoisted_280,
                            (0, vue_2.createElementVNode)("label", _hoisted_281, [
                                (0, vue_2.createElementVNode)("input", {
                                    onChange: handleStartOfMonthChange,
                                    value: localSettingsData.value.monthStart,
                                    class: "form-input form-small",
                                    type: "text",
                                    placeholder: "1"
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_282),
                                _hoisted_283
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" startOfYear "),
                        (0, vue_2.createElementVNode)("div", _hoisted_284, [
                            _hoisted_285,
                            (0, vue_2.createElementVNode)("label", _hoisted_286, [
                                (0, vue_2.createElementVNode)("input", {
                                    onChange: handleStartOfYearChange,
                                    value: localSettingsData.value.yearStart,
                                    class: "form-input form-small",
                                    type: "text",
                                    placeholder: "12"
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_287),
                                _hoisted_288
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" requestOff "),
                        (0, vue_2.createElementVNode)("div", _hoisted_289, [
                            (0, vue_2.createElementVNode)("div", _hoisted_290, [
                                _hoisted_291,
                                (0, vue_2.createElementVNode)("div", _hoisted_292, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_293
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasProPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_294))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event) => ((localSettingsData.value.requestOff) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.requestOff]
                                ]),
                                _hoisted_295
                            ], 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" roleRequestOff "),
                        (0, vue_2.createElementVNode)("div", _hoisted_296, [
                            (0, vue_2.createElementVNode)("div", _hoisted_297, [
                                _hoisted_298,
                                (0, vue_2.createElementVNode)("div", _hoisted_299, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_300
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasProPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_301))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event) => ((localSettingsData.value.roleRequestOff) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.roleRequestOff]
                                ]),
                                _hoisted_302
                            ], 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" hideTimeLess "),
                        (0, vue_2.createElementVNode)("div", _hoisted_303, [
                            (0, vue_2.createElementVNode)("div", _hoisted_304, [
                                _hoisted_305,
                                (0, vue_2.createElementVNode)("div", _hoisted_306, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_307
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasProPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_308))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event) => ((localSettingsData.value.hideTimeLess) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.hideTimeLess]
                                ]),
                                _hoisted_309
                            ], 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" staffLock "),
                        (0, vue_2.createElementVNode)("div", _hoisted_310, [
                            (0, vue_2.createElementVNode)("div", _hoisted_311, [
                                _hoisted_312,
                                (0, vue_2.createElementVNode)("div", _hoisted_313, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_314
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasProPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_315))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event) => ((localSettingsData.value.staffLock) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.staffLock]
                                ]),
                                _hoisted_316
                            ], 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" staffLockedSummary "),
                        (0, vue_2.createElementVNode)("div", _hoisted_317, [
                            (0, vue_2.createElementVNode)("div", _hoisted_318, [
                                _hoisted_319,
                                (0, vue_2.createElementVNode)("div", _hoisted_320, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_321
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasProPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_322))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event) => ((localSettingsData.value.staffLockedSummary) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.staffLockedSummary]
                                ]),
                                _hoisted_323
                            ], 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" shiftLockDate "),
                        (0, vue_2.createElementVNode)("div", _hoisted_324, [
                            (0, vue_2.createElementVNode)("div", _hoisted_325, [
                                _hoisted_326,
                                (0, vue_2.createElementVNode)("div", _hoisted_327, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_328
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_329, [
                                (0, vue_2.createElementVNode)("label", _hoisted_330, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleShiftLockYearChange,
                                        value: localSettingShiftLockDate.value.shiftLockYear,
                                        class: "form-input form-small",
                                        type: "text",
                                        placeholder: "2024"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_331),
                                    _hoisted_332
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_333, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleShiftLockMonthChange,
                                        value: localSettingShiftLockDate.value.shiftLockMonth,
                                        class: "form-input form-extra-small",
                                        type: "text",
                                        placeholder: "1"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_334),
                                    _hoisted_335
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_336, [
                                    (0, vue_2.createElementVNode)("input", {
                                        onChange: handleShiftLockDayChange,
                                        value: localSettingShiftLockDate.value.shiftLockDay,
                                        class: "form-input form-extra-small",
                                        type: "text",
                                        placeholder: "1"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_337),
                                    _hoisted_338
                                ])
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" maxConsecutiveWorkdays "),
                        (0, vue_2.createElementVNode)("div", _hoisted_339, [
                            (0, vue_2.createElementVNode)("div", _hoisted_340, [
                                _hoisted_341,
                                (0, vue_2.createElementVNode)("div", _hoisted_342, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_343
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_344, [
                                (0, vue_2.createElementVNode)("input", {
                                    onChange: handleMaxConsecutiveWorkdays,
                                    class: "form-input form-small",
                                    value: localSettingsData.value.maxConsecutiveWorkdays,
                                    type: "text",
                                    placeholder: "5"
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_345),
                                _hoisted_346
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" maxConsecutiveDaysOff "),
                        (0, vue_2.createElementVNode)("div", _hoisted_347, [
                            (0, vue_2.createElementVNode)("div", _hoisted_348, [
                                _hoisted_349,
                                (0, vue_2.createElementVNode)("div", _hoisted_350, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_351
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_352, [
                                (0, vue_2.createElementVNode)("input", {
                                    onChange: handleMaxConsecutiveDaysOff,
                                    class: "form-input form-small",
                                    value: localSettingsData.value.maxConsecutiveDaysOff,
                                    type: "text",
                                    placeholder: "5"
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_353),
                                _hoisted_354
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" minVacationWeekly (labor) "),
                        (0, vue_2.createElementVNode)("div", _hoisted_355, [
                            (0, vue_2.createElementVNode)("div", _hoisted_356, [
                                _hoisted_357,
                                (0, vue_2.createElementVNode)("div", _hoisted_358, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_359
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_360, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event) => ((localSettingsData.value.minVacationWeekly) = $event)),
                                    class: "labor-select form-input form-select"
                                }, [
                                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(7, (n) => {
                                        return (0, vue_2.createElementVNode)("option", {
                                            key: n - 1,
                                            value: n - 1
                                        }, (0, vue_2.toDisplayString)(n - 1), 9 /* TEXT, PROPS */, _hoisted_361);
                                    }), 64 /* STABLE_FRAGMENT */))
                                ], 512 /* NEED_PATCH */), [
                                    [vue_2.vModelSelect, localSettingsData.value.minVacationWeekly]
                                ])
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" minVacationMonthly (labor) "),
                        (0, vue_2.createElementVNode)("div", _hoisted_362, [
                            (0, vue_2.createElementVNode)("div", _hoisted_363, [
                                _hoisted_364,
                                (0, vue_2.createElementVNode)("div", _hoisted_365, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_366
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_367, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event) => ((localSettingsData.value.minVacationMonthly) = $event)),
                                    class: "labor-select form-input form-select"
                                }, [
                                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(32, (n) => {
                                        return (0, vue_2.createElementVNode)("option", {
                                            key: n - 1,
                                            value: n - 1
                                        }, (0, vue_2.toDisplayString)(n - 1), 9 /* TEXT, PROPS */, _hoisted_368);
                                    }), 64 /* STABLE_FRAGMENT */))
                                ], 512 /* NEED_PATCH */), [
                                    [vue_2.vModelSelect, localSettingsData.value.minVacationMonthly]
                                ])
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" maxWorkDaysPerMonth "),
                        (__props.isDefaultSettingsPage)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_369, [
                                (0, vue_2.createElementVNode)("div", _hoisted_370, [
                                    _hoisted_371,
                                    (0, vue_2.createElementVNode)("div", _hoisted_372, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_373
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_374, [
                                    _hoisted_375,
                                    (0, vue_2.createElementVNode)("div", _hoisted_376, [
                                        (0, vue_2.createElementVNode)("input", {
                                            value: localSettingsData.value.maxWorkDaysPerMonth,
                                            onInput: _cache[58] || (_cache[58] = ($event) => (localSettingsData.value.maxWorkDaysPerMonth = Number($event.target.value))),
                                            class: "form-input labor-day-input",
                                            type: "number",
                                            min: "0",
                                            max: "26",
                                            placeholder: "0"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_377),
                                        _hoisted_378
                                    ])
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createCommentVNode)(" maxVacationMonthly "),
                        (__props.isDefaultSettingsPage)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_379, [
                                (0, vue_2.createElementVNode)("div", _hoisted_380, [
                                    _hoisted_381,
                                    (0, vue_2.createElementVNode)("div", _hoisted_382, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_383
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_384, [
                                    _hoisted_385,
                                    (0, vue_2.createElementVNode)("div", _hoisted_386, [
                                        (0, vue_2.createElementVNode)("input", {
                                            value: localSettingsData.value.maxVacationMonthly,
                                            onInput: _cache[59] || (_cache[59] = ($event) => (localSettingsData.value.maxVacationMonthly = Number($event.target.value))),
                                            class: "form-input labor-day-input",
                                            type: "number",
                                            min: "0",
                                            max: "31",
                                            placeholder: "0"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_387),
                                        _hoisted_388
                                    ])
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createCommentVNode)(" maxWorkDaysPerWeek "),
                        (__props.isDefaultSettingsPage)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_389, [
                                (0, vue_2.createElementVNode)("div", _hoisted_390, [
                                    _hoisted_391,
                                    (0, vue_2.createElementVNode)("div", _hoisted_392, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_393
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_394, [
                                    _hoisted_395,
                                    (0, vue_2.createElementVNode)("div", _hoisted_396, [
                                        (0, vue_2.createElementVNode)("input", {
                                            value: localSettingsData.value.maxWorkDaysPerWeek,
                                            onInput: _cache[60] || (_cache[60] = ($event) => (localSettingsData.value.maxWorkDaysPerWeek = Number($event.target.value))),
                                            class: "form-input labor-day-input",
                                            type: "number",
                                            min: "0",
                                            max: "6",
                                            placeholder: "0"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_397),
                                        _hoisted_398
                                    ])
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createCommentVNode)(" maxWeekLaborMinutes "),
                        (__props.isDefaultSettingsPage)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_399, [
                                (0, vue_2.createElementVNode)("div", _hoisted_400, [
                                    _hoisted_401,
                                    (0, vue_2.createElementVNode)("div", _hoisted_402, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_403
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_404, [
                                    _hoisted_405,
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event) => ((localSettingsData.value.maxWeekLaborMinutes) = $event)),
                                        class: "form-input form-small",
                                        type: "text",
                                        placeholder: "HH:MM"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelText, localSettingsData.value.maxWeekLaborMinutes]
                                    ])
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createCommentVNode)(" maxMonthLaborMinutes "),
                        (__props.isDefaultSettingsPage)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_406, [
                                (0, vue_2.createElementVNode)("div", _hoisted_407, [
                                    _hoisted_408,
                                    (0, vue_2.createElementVNode)("div", _hoisted_409, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_410
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_411, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event) => ((localSettingsData.value.maxMonthLaborMinutes) = $event)),
                                        id: "max-month-labor-minutes",
                                        class: "max-month-labor-minutes form-input br-5",
                                        type: "text",
                                        placeholder: "HH:MM"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelText, localSettingsData.value.maxMonthLaborMinutes]
                                    ]),
                                    (0, vue_2.createElementVNode)("i", {
                                        class: "zmdi zmdi-calendar-note c-hand",
                                        onClick: handleCalendarClick
                                    })
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createCommentVNode)(" overtimeStartTime "),
                        (__props.isDefaultSettingsPage)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_412, [
                                (0, vue_2.createElementVNode)("div", _hoisted_413, [
                                    _hoisted_414,
                                    (0, vue_2.createElementVNode)("div", _hoisted_415, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_416
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_417, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event) => ((localSettingsData.value.overtimeStartTime) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.overtimeStartTime]
                                    ]),
                                    _hoisted_418
                                ]),
                                (localSettingsData.value.overtimeStartTime)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_419, [
                                        (0, vue_2.createElementVNode)("label", _hoisted_420, [
                                            _hoisted_421,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event) => ((localSettingsData.value.showOvertimeStartTime) = $event)),
                                                type: "checkbox",
                                                class: "overtime-start-time-checkbox"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelCheckbox, localSettingsData.value.showOvertimeStartTime]
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("input", {
                                            value: localSettingsData.value.overtimeStartTimeHours,
                                            onInput: handleOvertimeHoursInput,
                                            type: "number",
                                            step: "any",
                                            class: "form-input form-small overtime-start-time-hours-input",
                                            min: "0.5",
                                            max: "24"
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_422),
                                        _hoisted_423
                                    ]))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ]))
                            : (0, vue_2.createCommentVNode)("v-if", true)
                    ]),
                    (0, vue_2.createCommentVNode)(" Plan page settings "),
                    ((0, vue_2.unref)(hasProPerm))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_424, [
                            (0, vue_2.createElementVNode)("div", _hoisted_425, [
                                (0, vue_2.createVNode)(PlanManagementIcon_vue_1.default, { class: "page-title-text" }),
                                _hoisted_426
                            ]),
                            (0, vue_2.createCommentVNode)(" isPlanMemoInSummaryPage "),
                            (0, vue_2.createElementVNode)("div", _hoisted_427, [
                                (0, vue_2.createElementVNode)("div", _hoisted_428, [
                                    _hoisted_429,
                                    (0, vue_2.createElementVNode)("div", _hoisted_430, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_431
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_432, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event) => ((localSettingsData.value.isPlanMemoInSummaryPage) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.isPlanMemoInSummaryPage]
                                    ]),
                                    _hoisted_433
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" isPlanRevenueInSummaryPage "),
                            (0, vue_2.createElementVNode)("div", _hoisted_434, [
                                (0, vue_2.createElementVNode)("div", _hoisted_435, [
                                    _hoisted_436,
                                    (0, vue_2.createElementVNode)("div", _hoisted_437, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_438
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_439, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event) => ((localSettingsData.value.isPlanRevenueInSummaryPage) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.isPlanRevenueInSummaryPage]
                                    ]),
                                    _hoisted_440
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" isPlanNumEqInSummaryPage "),
                            (0, vue_2.createElementVNode)("div", _hoisted_441, [
                                (0, vue_2.createElementVNode)("div", _hoisted_442, [
                                    _hoisted_443,
                                    (0, vue_2.createElementVNode)("div", _hoisted_444, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_445
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_446, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event) => ((localSettingsData.value.isPlanNumEqInSummaryPage) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.isPlanNumEqInSummaryPage]
                                    ]),
                                    _hoisted_447
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" isPlanNumInSummaryPage "),
                            (0, vue_2.createElementVNode)("div", _hoisted_448, [
                                (0, vue_2.createElementVNode)("div", _hoisted_449, [
                                    _hoisted_450,
                                    (0, vue_2.createElementVNode)("div", _hoisted_451, [
                                        (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                        _hoisted_452
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_453, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event) => ((localSettingsData.value.isPlanNumInSummaryPage) = $event)),
                                        type: "checkbox"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, localSettingsData.value.isPlanNumInSummaryPage]
                                    ]),
                                    _hoisted_454
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_455, [
                        _hoisted_456,
                        (0, vue_2.createCommentVNode)(" hideLiveChat "),
                        (0, vue_2.createElementVNode)("div", _hoisted_457, [
                            (0, vue_2.createElementVNode)("div", _hoisted_458, [
                                _hoisted_459,
                                (0, vue_2.createElementVNode)("div", _hoisted_460, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_461
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_462, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event) => ((localSettingsData.value.hideLiveChat) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.hideLiveChat]
                                ]),
                                _hoisted_463
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" staffNoBoard "),
                        (0, vue_2.createElementVNode)("div", _hoisted_464, [
                            (0, vue_2.createElementVNode)("div", _hoisted_465, [
                                _hoisted_466,
                                (0, vue_2.createElementVNode)("div", _hoisted_467, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_468
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasProPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_469))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledBtn.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event) => ((localSettingsData.value.staffNoBoard) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.staffNoBoard]
                                ]),
                                _hoisted_470
                            ], 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" AutoConsec "),
                        (0, vue_2.createElementVNode)("div", _hoisted_471, [
                            (0, vue_2.createElementVNode)("div", _hoisted_472, [
                                _hoisted_473,
                                (0, vue_2.createElementVNode)("div", _hoisted_474, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_475
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasAutoPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_476))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledAuto.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event) => ((localSettingsData.value.autoConsec) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.autoConsec]
                                ]),
                                _hoisted_477
                            ], 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" AutoConsecDaysOfff "),
                        (0, vue_2.createElementVNode)("div", _hoisted_478, [
                            (0, vue_2.createElementVNode)("div", _hoisted_479, [
                                _hoisted_480,
                                (0, vue_2.createElementVNode)("div", _hoisted_481, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_482
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasAutoPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_483))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["settings-input oplus-form-switch", disabledAuto.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event) => ((localSettingsData.value.autoConsecDaysOff) = $event)),
                                    type: "checkbox"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelCheckbox, localSettingsData.value.autoConsecDaysOff]
                                ]),
                                _hoisted_484
                            ], 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" shiftInterval "),
                        (0, vue_2.createElementVNode)("div", _hoisted_485, [
                            (0, vue_2.createElementVNode)("div", _hoisted_486, [
                                _hoisted_487,
                                (0, vue_2.createElementVNode)("div", _hoisted_488, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_489
                                ])
                            ]),
                            (!(0, vue_2.unref)(hasAutoPerm))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_490))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("label", {
                                class: (0, vue_2.normalizeClass)(["form-label settings-input", disabledAuto.value])
                            }, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event) => ((shiftInterval).value = $event)),
                                    class: "form-input oplus-input-time",
                                    type: "time"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelText, shiftInterval.value]
                                ])
                            ], 2 /* CLASS */)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_491, [
                        (0, vue_2.createElementVNode)("button", {
                            class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn", loadingClass.value]),
                            onClick: handleShiftSubmit
                        }, "確定", 2 /* CLASS */)
                    ])
                ], 2 /* CLASS */));
        };
    }
});
